<template>
   <v-btn
    v-if="config.public.showBackActions"
    icon
    @click="$emit('goBack')"
  >
    <v-icon>mdi-arrow-left</v-icon>
  </v-btn>
</template>
<script lang="ts">
export default defineComponent({
  name: "ComponentsElementsFormNavigateBack",
  setup() {
    const config = useRuntimeConfig()
    return { config }
  },
})
</script>
